import { fromJS } from 'immutable';
import * as actionTypes from '../actions/workspacePreviewActionTypes';
import { umoSelectCaseReducer } from '../utils/umoUtils';

const initialState = fromJS({
  selectedID: null,
  selectedData: { name: null, description: null },
  request: null,
  isRequesting: false,
  umoList: [],
  selectedUMOIDs: [],
  isSelectAll: false,
});

const workspacePreview = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.WORKSPACE_PREVIEW_RETRIEVE_REQUEST:
      if (state.get('request') && state.get('request').cancel) {
        state.get('request').cancel();
      }
      return state
        .set('request', action.requestPromise)
        .set('isRequesting', true)
        .set('selectedID', action.workspaceID)
        .set('selectedData', fromJS({
          name: action.workspaceName,
          description: action.workspaceDescription,
        }))
        .set('umoList', fromJS([]))
        .set('selectedUMOIDs', fromJS([]))
        ;
    case actionTypes.WORKSPACE_PREVIEW_RETRIEVE_SUCCESS:
      return state
        .set('request', null)
        .set('isRequesting', false)
        .set('selectedID', action.workspaceID)
        .set('selectedData', fromJS({
          name: action.workspaceName,
          description: action.workspaceDescription,
        }))
        .set('umoList', fromJS(action.umoList))
        ;
    case actionTypes.WORKSPACE_PREVIEW_RETRIEVE_FAILURE:
      return state
        .set('request', action.err)
        .set('isRequesting', false)
        ;
    case actionTypes.WORKSPACE_PREVIEW_SELECT_TOGGLE: {
      return umoSelectCaseReducer(state, action);
    }
    case actionTypes.WORKSPACE_PREVIEW_SELECT_ALL:
      return state
        .set('isSelectAll', true);
    case actionTypes.WORKSPACE_PREVIEW_DESELECT_ALL:
      return state
        .set('selectedUMOIDs', fromJS([]))
        .set('isSelectAll', false);
    default:
      return state;
  }
};

export default workspacePreview;



// WEBPACK FOOTER //
// ./src/js/reducers/workspacePreview.js